import { EMPTY, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import Modal from './modal';

interface StorageItem {
  hasBeenShown: boolean;
}

class Popup extends Modal {
  private get _hasBeenShown() {
    const str = window.sessionStorage.getItem(this._modalId);

    if (!str) return false;

    const { hasBeenShown } = JSON.parse(str) as StorageItem;

    return hasBeenShown;
  }

  private _show() {
    if (this._hasBeenShown) return;

    const subscription = of(EMPTY).pipe(delay(2500)).subscribe(this.open.bind(this));
    this._addSubscription(subscription);
  }

  public open() {
    super.open();

    const storageItem: StorageItem = { hasBeenShown: true };
    window.sessionStorage.setItem(this._modalId, JSON.stringify(storageItem));
  }

  protected _onEnter() {
    super._onEnter();
    this._show();
  }
}

export default Popup;
